/**
 * お届け予定商品一覧を担う　
 */
import { useState, useEffect } from 'react';
import { SubscriptionState, SubscriptionLineDetail } from '../App/useSubscription';

export const useRegisteredProduct = (
  subscription: SubscriptionState
) => {
  const [registeredProducts, setRegisteredProducts] = useState<ProductInfo[]>([]);

  useEffect(() => {
    if (!subscription) return;

    const products = subscription.subscriptionLines.map(subscriptionLine => {
      return createProductInfo(subscriptionLine, true);
    });

    setRegisteredProducts(products);

  }, [subscription?.subscriptionLines]);

  return registeredProducts;
};

const createProductInfo = (line: SubscriptionLineDetail, active: boolean): ProductInfo => {

  return {
    productTitle: line.title,
    image: line.variantImage,
    variantTitle: line.variantTitle,
    originalPrice: line.lineDiscountedPriceAmount,
    price: line.currentPriceAmount,
    quantity: line.quantity,
    variantId: line.variantId,
    lineId: line.lineId,
    url: line.onlineStorePreviewUrl,
    active,
  };
};

// types

export type ProductInfo = {
  productTitle: string;
  image?: string;
  variantTitle: string;
  originalPrice: number;
  price: number;
  quantity: number;
  variantId: string;
  planId?: string;
  lineId?: string;
  url: string;
  active: boolean;
}
